module.exports = __webpack_public_path__ + "static/media/CPO1-thumb.19e86863.jpg";